/* common cookie get/set */
export default {
  get: function (cookieName) {
    let matchName = cookieName + '=';
    let cookieList = document.cookie.split(';');
    for(var cookieCount=0; cookieCount<cookieList.length; cookieCount++) {
      let thisCookie = cookieList[cookieCount];
      while (thisCookie.charAt(0)==' ') thisCookie = thisCookie.substring(1);
      if (thisCookie.indexOf(matchName) == 0) return thisCookie.substring(matchName.length,thisCookie.length);
    }
    return null;
  },
  set: function(cookieName, cookieValue, daysToExpire) {
    let cookieExpires = '';
    let cookieString='';
    //if no daysToExpire, expires with session
    if(typeof daysToExpire === 'number')  {
      let d = new Date();
      d.setTime(d.getTime() + (daysToExpire*24*60*60*1000)); //set for specifed time
      cookieExpires = 'expires='+d.toUTCString();
    }
    document.cookie = (cookieName + '=' + cookieValue + '; ' + cookieExpires +'; path=/');
  }
};
